import ProjectCore, { IProject } from "./ProjectCore";

export interface IProjectCSP extends IProject {}

export default class ProjectCSP extends ProjectCore {
  constructor(dto: IProjectCSP) {
    super(dto);
    Object.assign(this, dto);
  }
}
